import { Shield, Users, Truck, Star, Award, ClipboardCheck } from "lucide-react";

const badges = [
  { icon: Shield, label: "Licensed & Insured", sub: "USDOT + KY Certified" },
  { icon: Users, label: "Family Owned", sub: "Louisville-Born · Louisville-Run" },
  { icon: Truck, label: "500+ Moves", sub: "Local & Long-Distance" },
  { icon: Star, label: "4.9★ Google", sub: "Real Customer Reviews" },
  { icon: Award, label: "Same-Week", sub: "Availability Guaranteed" },
  { icon: ClipboardCheck, label: "No Hidden Fees", sub: "Written Estimate · Up Front" },
];

export default function TrustBar() {
  return (
    <section
      className="bg-[#151816] text-white py-8 lg:py-12 border-t-4 border-[#5BB239]"
      data-testid="trust-bar"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center mb-6 lg:mb-8">
          <div className="overline text-[#5BB239]">Why 500+ Kentucky families chose us</div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/10">
          {badges.map((b, i) => (
            <div
              key={i}
              className="bg-[#151816] p-5 lg:p-6 flex flex-col items-center text-center hover:bg-[#1e2320] transition-colors"
              data-testid={`trust-badge-${i}`}
            >
              <div className="w-11 h-11 bg-[#5BB239]/15 border border-[#5BB239]/30 flex items-center justify-center">
                <b.icon className="w-5 h-5 text-[#5BB239]" strokeWidth={2.25} />
              </div>
              <div className="mt-3 font-display font-black text-sm tracking-tight leading-none">
                {b.label}
              </div>
              <div className="mt-1.5 font-mono-label text-[9px] text-white/50 leading-tight">
                {b.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
